module.exports = __webpack_public_path__ + "static/img/yAxis.922c798b.svg";